<template>
    <header class="header">
        <navbar v-if="$route.name !== 'login'"/>
    </header>
    <sidebar v-if="$route.name !== 'login' && $route.name !== 'invoice'" :routeName="routeName" />
    <main
        class="main" 
        :class="[
            $route.name !== 'login' ? '' : 'main_login',
            $route.name === 'invoice' ? 'main_invoice' : '',
            $route.name === 'chat' ? 'chat' : '',
            $route.meta.group === 'game' ? 'game' : '',
            sidebarCollapsed ? 'sidebar-collapsed' : ''
        ]"
    >
        <router-view v-slot="{ Component }">
            <Transition name="fade">
                <component :is="Component" />
            </Transition>
        </router-view>
        <div
            v-if="$route.name !== 'login' && $route.name !== 'chat'"
            class="bg_bottom"
        ></div>
    </main>
    <div v-if="isLoading" class="preloader-wrapper">
        <div class="preloader preloader_1"></div>
        <div class="preloader preloader_2"></div>
    </div>
    <NewNotificationModal :item="new_notification" />
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import NewNotificationModal from "@/components/modals/notification/NewNotificationModal.vue";
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {
            routeName: "home",
        };
    },

    components: {
        Navbar,
        Sidebar,
        NewNotificationModal
    },

    computed: {
        ...mapState({
            token: (state) => state.token,
            isLoading: (state) => state.isLoading,
            new_notification: (state) => state.notifications.new_notification,
            sidebarCollapsed: (state) => state.sidebarCollapsed,
        }),
    },

    methods: {
        ...mapActions({
            getProfileData: "getProfileData",
            fetchNotifications: "notifications/fetchNotifications"
        }),

        checkAuthRequests() {
            const isLoginRoute =
                this.$route.name === "login" ||
                this.$route.path === "/login" ||
                this.$route.path.startsWith("/login");

            if (this.token && !isLoginRoute) {
                this.getProfileData();
                this.fetchNotifications();
            }
        }
    },

    updated() {
        this.routeName = this.$route.name;
    },

    mounted() {
        this.checkAuthRequests();
    },

    watch: {
        '$route.path'() {
            this.checkAuthRequests();
        }
    }
};
</script>
<style scoped lang="sass">
.bg_bottom
    position: absolute
    bottom: 0
    left: 0
    margin-top: 48px
    display: flex
    align-items: center
    justify-content: center
    width: 100%
    height: 100px
    background: url('@/assets/img/decor/People.png'), url('@/assets/img/decor/People2.png')
    background-repeat: no-repeat
    background-position: left 30px top 0, right 30px top 0 
</style>